import { apiGet, apiPost, abortableApiPost } from './fetch';
import {
    AlarmMap, Credentials, DeviceId, DeviceGroupMap, DeviceMap, PolicyMap, UserMap, PollData,
    ServerDetails, UtcTime, LprPlateList, SessionId,
} from 'types';
import * as moment from 'moment';
import { baseUrl } from './baseUrl';
import * as webrtcApi from './webrtc';
import * as cameraApi from './camera';
import * as reportsApi from './reports';

export const webrtc = webrtcApi;
export const camera = cameraApi;
export const reports = reportsApi;

export const formatDate = (utcDate: Date, tzOffsetCalculator: (t: UtcTime) => number) =>
    moment
        .utc(utcDate)
        .utcOffset(tzOffsetCalculator(utcDate.getTime()))
        .format('YYYYMMDD')
;

export type LoginResponse = {
    sessionId: SessionId; // TODO: remove this once web reports are in new Web Client
    admin: boolean;
    isPasswordResetRequired: boolean;
    isPasswordExpired: boolean;
    permissions: {
        viewAlarms: boolean;
    };
};

export const login = async (credentials: Credentials) =>
    await apiPost<Credentials, LoginResponse>(`${baseUrl}/login`, credentials)
;

export type JoinRequest = {
    url: string;
    token: string;
    v: string;
};

export const join = async () =>
    await apiPost<JoinRequest, LoginResponse>(`${baseUrl}/join`)
;

export const logout = async () =>
    await apiPost<undefined>(`${baseUrl}/logout`)
;

export const getPolicies = async () =>
    await apiGet<PolicyMap>(`${baseUrl}/policies`)
;

export const getUsers = async () =>
    await apiGet<UserMap>(`${baseUrl}/users`)
;

export const getDevices = async () =>
    await apiGet<DeviceMap>(`${baseUrl}/devices`)
;

export const getDeviceGroups = async () =>
    await apiGet<DeviceGroupMap>(`${baseUrl}/deviceGroups`)
;

export const getAlarms = async (utcDate: Date, tzOffsetCalculator: (t: UtcTime) => number) =>
    await apiGet<AlarmMap>(`${baseUrl}/alarms/${formatDate(utcDate, tzOffsetCalculator)}`)
;

type PollRequest = {
    deviceIds: DeviceId[];
};

export const postPoll = async (deviceIds: DeviceId[], signal: AbortSignal) =>
    await abortableApiPost<PollRequest, PollData>(`${baseUrl}/poll`, signal, { deviceIds })
;

export const getServerDetails = async () =>
    await apiGet<ServerDetails>(`${baseUrl}/server`)
;

export const getLprPlateLists = async () =>
    await apiGet<LprPlateList[]>(`${baseUrl}/lpr/lists`)
;



// WEBPACK FOOTER //
// ./src/api/index.ts